import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { LBL_ADD_NEW, LBL_APP_NAME, LBL_SETTINGS, LBL_BASIC_CONFIGS, LBL_BASIC_CONFIGURATIONS } from '../../configs/labelConfigs';
import Toast from '../commons/helpers/toast';

import { userGroupUrlCheck } from '../../utils/userGroupUrlCheck';
import * as labelConfigs from '../../configs/labelConfigs';
import { clearAction } from '../../actions/commonActions';
import * as staticConfigs from '../../configs/staticConfigs';
class BasicConfig extends Component {

    constructor(props) {
        super()
        this.state = {
            userGroup: "",
            activeRowId: 0,
            toastMessage: '',
            toastFlag: false,
            toastSuccess: true,
        }
    }

    componentDidMount() {
        const { location } = this.props;
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = '';
        if (userGroupData !== undefined) {
            userGroup = userGroupData.user_group;
            this.setState({ userGroup:userGroup });
        }

        document.title = LBL_APP_NAME + " - " + LBL_SETTINGS + " -  " + LBL_BASIC_CONFIGURATIONS;
        if (userGroup === staticConfigs.LOGIN_AFFILIATE_GROUP) {
            document.body.classList.add('body-affiliate');
        }
    }

    render() {

        const {
            toastMessage, toastFlag, toastSuccess, userGroup
        } = this.state

        const { status } = this.props;

        if (status === 401 || status === 403) {
            if (userGroup === staticConfigs.LOGIN_AFFILIATE_GROUP) {
                return <Redirect to={staticConfigs.ROUTE_AFFILIATE_REFRESH} />;
            } else {
                return <Redirect to={staticConfigs.ROUTE_REFRESH} />;

            }
        }
        // let superAdminBasicConfig = [ 
        //     { menuName: labelConfigs.LBL_SKILLS, menuLink: staticConfigs.ROUTE_SKILLS },
        //     { menuName: labelConfigs.LBL_CLIENT_CATEGORIES, menuLink: staticConfigs.ROUTE_CLIENT_CATEGORY },
        //     { menuName: labelConfigs.LBL_CLIENT_DOCUMENTS, menuLink: staticConfigs.ROUTE_CLIENT_DOCS },
        //     { menuName: labelConfigs.LBL_CREW_DOCUMENTS, menuLink: staticConfigs.ROUTE_CREW_DOCS },
        //     { menuName: labelConfigs.LBL_DYNAMIC_FIELDS_CLIENTS, menuLink: staticConfigs.ROUTE_DYNAMIC_FIELDS_CLIENTS },
        //     { menuName: labelConfigs.LBL_DYNAMIC_FIELDS_CREW, menuLink: staticConfigs.ROUTE_DYNAMIC_FIELDS_CREW },
        //     { menuName: labelConfigs.LBL_DYNAMIC_FIELDS_AFFILIATES, menuLink: staticConfigs.ROUTE_DYNAMIC_FIELDS_AFFILIATES },
        //     { menuName: labelConfigs.LBL_VEHICLE_INFO, menuLink: staticConfigs.ROUTE_VEHICLE_INFO },
        // ];

        // let affiliateBasicConfig = [
        //     { menuName: labelConfigs.LBL_SKILLS, menuLink: staticConfigs.ROUTE_AFFILIATE_SKILLS },
        //     { menuName: labelConfigs.LBL_CLIENT_CATEGORIES, menuLink: staticConfigs.ROUTE_AFFILIATE_CLIENT_CATEGORY },
        //     { menuName: labelConfigs.LBL_CLIENT_DOCUMENTS, menuLink: staticConfigs.ROUTE_AFFILIATE_CLIENT_DOCS },
        //     { menuName: labelConfigs.LBL_CREW_DOCUMENTS, menuLink: staticConfigs.ROUTE_AFFILIATE_CREW_DOCS },
        //     { menuName: labelConfigs.LBL_DYNAMIC_FIELDS_CLIENTS, menuLink: staticConfigs.ROUTE_AFFILIATE_DYNAMIC_FIELDS_CLIENTS },
        //     { menuName: labelConfigs.LBL_DYNAMIC_FIELDS_CREW, menuLink: staticConfigs.ROUTE_AFFILIATE_DYNAMIC_FIELDS_CREW },
        //     { menuName: labelConfigs.LBL_VEHICLE_INFO, menuLink: staticConfigs.ROUTE_AFFILIATE_VEHICLE_INFO },
        // ];

        return (
            <div className="col-md-8">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="box">
                    <div className="box-content">
                        <div className="table-responsive">
                            <div className="col-11 padding-left-50 margin-top-25">

                                {userGroup === staticConfigs.LOGIN_SUPER_ADMIN_GROUP && <>
                                    <div className="row">
                                        <div className="col-7">
                                            <div className="row basic-config-header">General</div>
                                            <div className="row basic-config-item"><Link to={staticConfigs.ROUTE_SKILLS}>{labelConfigs.LBL_SKILLS}</Link></div>

                                            <div className="row basic-config-header"><strong>Staff</strong></div>
                                            <div className="row basic-config-item"><Link to={staticConfigs.ROUTE_CREW_DOCS}>{labelConfigs.LBL_CREW_DOCUMENTS}</Link></div>
                                            <div className="row basic-config-item" ><Link to={staticConfigs.ROUTE_DYNAMIC_FIELDS_CREW}>{labelConfigs.LBL_DYNAMIC_FIELDS_CREW}</Link></div>
                                            
                                        </div>
                                        <div className="col-5">
                                            <div className="row basic-config-header"><strong>Affiliate</strong></div>
                                            <div className="row basic-config-item"><Link to={staticConfigs.ROUTE_DYNAMIC_FIELDS_AFFILIATES}>{labelConfigs.LBL_DYNAMIC_FIELDS_AFFILIATES}</Link></div>
                                            <div className="row basic-config-header"><strong>Client</strong></div>
                                            <div className="row basic-config-item"><Link to={staticConfigs.ROUTE_CLIENT_DOCS}>{labelConfigs.LBL_CLIENT_DOCUMENTS}</Link></div>
                                            <div className="row basic-config-item"><Link to={staticConfigs.ROUTE_CLIENT_CATEGORY}>{labelConfigs.LBL_CLIENT_CATEGORIES}</Link></div>
                                            <div className="row basic-config-item"><Link to={staticConfigs.ROUTE_DYNAMIC_FIELDS_CLIENTS}>{labelConfigs.LBL_DYNAMIC_FIELDS_CLIENTS}</Link></div>
                                        </div>
                                    </div>

                                    {/* <div className="row">
                                        <div className="col-7">
                                            <p><Link to={staticConfigs.ROUTE_SKILLS}><div className='normalText'>{labelConfigs.LBL_SKILLS}</div></Link></p>
                                        </div>
                                        <div className="col-5">
                                            <p><Link to={staticConfigs.ROUTE_DYNAMIC_FIELDS_CLIENTS}><div className='normalText'>{labelConfigs.LBL_DYNAMIC_FIELDS_CLIENTS}</div></Link></p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-7">
                                            <p><Link to={staticConfigs.ROUTE_CLIENT_CATEGORY}><div className='normalText'>{labelConfigs.LBL_CLIENT_CATEGORIES}</div></Link></p>
                                        </div>
                                        <div className="col-5">
                                            <p><Link to={staticConfigs.ROUTE_DYNAMIC_FIELDS_CREW}><div className='normalText'>{labelConfigs.LBL_DYNAMIC_FIELDS_CREW}</div></Link></p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-7">
                                            <p><Link to={staticConfigs.ROUTE_CLIENT_DOCS}><div className='normalText'>{labelConfigs.LBL_CLIENT_DOCUMENTS}</div></Link></p>
                                        </div>
                                        <div className="col-5">
                                            <p><Link to={staticConfigs.ROUTE_DYNAMIC_FIELDS_AFFILIATES}><div className='normalText'>{labelConfigs.LBL_DYNAMIC_FIELDS_AFFILIATES}</div></Link></p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-7">
                                            <p><Link to={staticConfigs.ROUTE_CREW_DOCS}><div className='normalText'>{labelConfigs.LBL_CREW_DOCUMENTS}</div></Link></p>
                                        </div>
                                        <div className="col-5">
                                            <p><Link to={staticConfigs.ROUTE_VEHICLE_INFO}><div className='normalText'>{labelConfigs.LBL_VEHICLE_INFO}</div></Link></p>
                                        </div>
                                    </div> */}
                                </>
                                }

{/* General - Skills. 
Client - Dynamic Fields for Clients, Client Categories ,Client Documents. 
Staff - Dynamic Fields for Staff, Staff Documents. 
In SA, another section Affiliate */}
                                {userGroup === staticConfigs.LOGIN_AFFILIATE_GROUP && <>
                                    <div className="row">
                                        <div className="col-7">
                                            <div className="row basic-config-header">General</div>
                                            <div className="row basic-config-item"><Link to={staticConfigs.ROUTE_AFFILIATE_SKILLS}>{labelConfigs.LBL_SKILLS}</Link></div>

                                            <div className="row basic-config-header"><strong>Staff</strong></div>
                                            <div className="row basic-config-item"><Link to={staticConfigs.ROUTE_AFFILIATE_CREW_DOCS}>{labelConfigs.LBL_CREW_DOCUMENTS}</Link></div>
                                            <div className="row basic-config-item" ><Link to={staticConfigs.ROUTE_AFFILIATE_DYNAMIC_FIELDS_CREW}>{labelConfigs.LBL_DYNAMIC_FIELDS_CREW}</Link></div>
                                            
                                        </div>
                                        <div className="col-5">
                                            <div className="row basic-config-header"><strong>Client</strong></div>
                                            <div className="row basic-config-item"><Link to={staticConfigs.ROUTE_AFFILIATE_CLIENT_DOCS}>{labelConfigs.LBL_CLIENT_DOCUMENTS}</Link></div>
                                            <div className="row basic-config-item"><Link to={staticConfigs.ROUTE_AFFILIATE_CLIENT_CATEGORY}>{labelConfigs.LBL_CLIENT_CATEGORIES}</Link></div>
                                            <div className="row basic-config-item"><Link to={staticConfigs.ROUTE_AFFILIATE_DYNAMIC_FIELDS_CLIENTS}>{labelConfigs.LBL_DYNAMIC_FIELDS_CLIENTS}</Link></div>
                                        </div>
                                    </div>


                                    {/* <div className="row">
                                        <div className="col-7">
                                            <p><Link to={staticConfigs.ROUTE_AFFILIATE_SKILLS}>{labelConfigs.LBL_SKILLS}</Link></p>
                                        </div>
                                        <div className="col-5">
                                            <p><Link to={staticConfigs.ROUTE_AFFILIATE_DYNAMIC_FIELDS_CLIENTS}>{labelConfigs.LBL_DYNAMIC_FIELDS_CLIENTS}</Link></p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-7">
                                            <p><Link to={staticConfigs.ROUTE_AFFILIATE_CLIENT_CATEGORY}>{labelConfigs.LBL_CLIENT_CATEGORIES}</Link></p>
                                        </div>
                                        <div className="col-5">
                                            <p><Link to={staticConfigs.ROUTE_AFFILIATE_DYNAMIC_FIELDS_CREW}>{labelConfigs.LBL_DYNAMIC_FIELDS_CREW}</Link></p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-7">
                                            <p><Link to={staticConfigs.ROUTE_AFFILIATE_CLIENT_DOCS}>{labelConfigs.LBL_CLIENT_DOCUMENTS}</Link></p>
                                        </div>
                                        <div className="col-5">
                                            <p><Link to={staticConfigs.ROUTE_AFFILIATE_CREW_DOCS}>{labelConfigs.LBL_CREW_DOCUMENTS}</Link></p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-7">
                                            <p><Link to={staticConfigs.ROUTE_AFFILIATE_VEHICLE_INFO}>{labelConfigs.LBL_VEHICLE_INFO}</Link></p> 
                                        </div>
                                        <div className="col-5">
                                            <p>&nbsp;</p>
                                        </div>
                                    </div> */}
                                </>
                                }
                            </div>
                            <div className="clear-b-scroll-sector">&nbsp;</div>
                            <div>&nbsp;</div>
                        </div>
                    </div>
                </div>


            </div>
        )

    }

}
const mapStateToProps = (state) => {
    return {
        status: state.otherExps.status,
        activity: state.otherExps.activity,
    }
}
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        clearAction: clearAction
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(BasicConfig);